import { useAppBuilderContext } from 'app/app/editor/context';
import { useMemo } from 'react';

export function useElementIsActive(componentUid: string | null | undefined, nodeUid: string | undefined): boolean {
    const ctx = useAppBuilderContext();
    return useMemo(() => {
        return componentUid === nodeUid && ctx.componentQuerySelector === null;
    }, [componentUid, nodeUid, ctx.componentQuerySelector]);
}
